import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { httpClient } from '@/api/http-client'
import { TaxPaymentSlip } from '@/types'

export type UpdateTaxPaymentSlipPaidParams = {
  company_key: string
  paid: boolean
  slip_key: string
}

export async function updateTaxPaymentSlipPaid({
  company_key,
  paid,
  slip_key,
}: UpdateTaxPaymentSlipPaidParams) {
  const response = await httpClient('accounting-dealer').put<TaxPaymentSlip>(
    `/v3/company/${company_key}/tax-payment-slips/${slip_key}/paid`,
    { paid },
  )

  return response.data
}

export function useUpdateTaxPaymentSlipPaid(
  options?: UseMutationOptions<
    TaxPaymentSlip,
    AxiosError,
    UpdateTaxPaymentSlipPaidParams
  >,
) {
  return useMutation({
    mutationFn: updateTaxPaymentSlipPaid,
    ...options,
  })
}
